import { Price, Store, Subscription, SubscriptionItem } from 'src/dao/core-dao'

const PRICE_LOCALE = 'en-GB'

function formatMoney(amount: number, currency: string): string {
  return new Intl.NumberFormat(PRICE_LOCALE, { style: 'currency', currency }).format(amount)
}

function formatRecurringSuffix(recurring: { interval?: string; intervalCount?: number } | undefined): string {
  if (!recurring?.interval) return ''
  const count = recurring.intervalCount ?? 1
  return count > 1 ? ` per ${count} ${recurring.interval}s` : ` per ${recurring.interval}`
}

export const subscriptionUtil = {
  /** API uses `app_store` (RevenueCat); legacy client may use `ios`. */
  isIosStore: (store: Store | null | undefined): boolean => store === 'ios' || store === 'app_store',
  /** API uses `play_store` (RevenueCat); legacy client may use `android`. */
  isAndroidStore: (store: Store | null | undefined): boolean => store === 'android' || store === 'play_store',
  isAppStoreSubscription: (store: Store | null | undefined): boolean =>
    subscriptionUtil.isIosStore(store) || subscriptionUtil.isAndroidStore(store) || store === 'test_store',
  getManagementText: (store: Store | null | undefined): string => {
    if (subscriptionUtil.isIosStore(store)) {
      return 'Manage your subscription in the App Store'
    }
    if (subscriptionUtil.isAndroidStore(store)) {
      return 'Manage your subscription in Google Play'
    }
    if (store === 'test_store') {
      return 'Manage your subscription in the App Store or Google Play (sandbox)'
    }
    return 'Please check your settings/billing page on desktop to manage your payments.'
  },

  formatCatalogPrice: (price: Price): string =>
    `${formatMoney(price.amount ?? 0, price.currency)}${formatRecurringSuffix(price.recurring)}`,

  formatSubscriptionItemPrice: (item: SubscriptionItem): string => {
    const { amount, currency } = item.plan
    if (amount < 0) {
      return 'See App Store or Google Play for price'
    }
    return `${formatMoney(amount, currency)}${formatRecurringSuffix(item.price.recurring)}`
  },

  subscriptionIsTerminated: (subscription: Subscription): boolean =>
    subscription.status === 'canceled' || !!subscription.canceledAt,
}
